<template>
    <div>
        <h2 class="u-margin-top-30 u-margin-bottom-30">
            Future Purchases
        </h2>

        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__item">
                <control for="future_purchase" label="Are There Future Purchases?">
                    <select id="future_purchase"
                            v-model="futurePurchases"
                            v-field-control
                            required>
                        <option :value="null" disabled hidden>Please select...</option>
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </control>
            </div>
        </div>

        <div v-if="futurePurchases" class="u-margin-bottom-30">
            <div v-for="(purchase, purchaseIndex) in purchases">
                <futurePurchase
                    :index="purchaseIndex"
                    :purchase="purchase"
                ></futurePurchase>
            </div>
            <button type="button" class="a-button" @click="addPurchase">Add Another Future Purchase</button>
        </div>

        <div v-if="futurePurchases && purchasesTotal">
            <div class="a-table a-table--short-no-style a-table--full-width u-margin-top-30">
                <table cellspacing="0" cellpadding="0" class="a-table--full-width">
                    <thead>
                    <tr>
                        <th>Purchase</th>
                        <th>Type</th>
                        <th>Initial Purchase Date</th>
                        <th>Last Purchase Date</th>
                        <th>Deferment Period</th>
                        <th>Age at Purchase</th>
                        <th>Multiplicand</th>
                        <th>Multiplier</th>
                        <th v-if="showResaleColumn()">Resale Total</th>
                        <th>Formula</th>
                        <th>Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="purchase in purchases">
                        <td>{{ jsUcfirst(purchase.description) }}</td>
                        <td>{{ jsUcfirst(purchase.type) }}</td>
                        <td>{{ purchase.purchaseDate }}</td>
                        <td>{{ purchase.purchaseEnd || 'N/A' }}</td>
                        <td>{{ defermentPeriod(purchase) }} years</td>
                        <td>{{ purchase.ageAtPurchase }} years</td>
                        <td>{{ currencyFormat(purchase.multiplicand) }}</td>
                        <td>{{ purchase.discount }}</td>
                        <td v-if="showResaleColumn()">{{ currencyFormat(purchase.resaleTotal) }}</td>
                        <td v-if="purchase.resaleTotal > 0">
                            ({{ currencyFormat(purchase.multiplicand) }} X {{ purchase.discount}}) - {{ currencyFormat(purchase.resaleTotal) }}
                        </td>
                        <td v-else>
                            {{ currencyFormat(purchase.multiplicand) }} X {{ purchase.discount}}
                        </td>
                        <td>{{ currencyFormat(purchase.total) }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                        <tr class="a-table--grey">
                            <td class="u-text-right u-bold" :colspan="showResaleColumn() ? 10 : 9">Total</td>
                            <td><strong>{{ currencyFormat(purchasesTotal) }}</strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import roundValue from 'mixins/roundValue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import {mapActions, mapGetters} from 'vuex';
    import futurePurchase from './FuturePurchase.vue';

    export default {
        name: 'future-purchases',
        props: ['stepValid'],
        mixins: [
            FormValidator,
            currencyFormat,
            roundValue,
        ],
        components: {
            Control,
            ControlError,
            DateInput,
            futurePurchase
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/otherFutureLosses', [
                'value',
                'purchaseValue',
                'purchasesTotal'
            ]),
            ...mapGetters('personal/claimant', [
                'claimant',
                'getClaimInfo',
            ]),
            futurePurchases: {
                get() {
                    return this.value('futurePurchases');
                },
                set(value) {
                    this.set({key: 'futurePurchases', value});
                }
            },
            purchases: {
                get() {
                    return this.value('purchases');
                },
            },
            isStepValid() {
                if (this.futurePurchases === false) {
                    return true;
                }
            },
        },
        methods: {
            ...mapActions('personal/otherFutureLosses', [
                'set',
                'setPurchase',
                'addPurchase'
            ]),
            jsUcfirst(string) {
                if (string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                return "";
            },
            defermentPeriod(purchase) {
                return moment(purchase.purchaseDate, 'DD/MM/YYYY').diff(
                    moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY'), 'Y', true).toFixed(2);
            },
            showResaleColumn() {
                if (this.purchases.length) {
                    return (this.purchases.reduce((total, purchase) => total + purchase.resaleValue, 0) > 0);
                }
                return false;
            }
        },
    }
</script>


// WEBPACK FOOTER //
// FuturePurchases.vue?e47cf616